import styled from 'styled-components';

import { black, blue, border1, gray } from 'utils/style/colors';

import Icon from 'components/Icon';
import HoverIcon from 'components/HoverIcon';

export const Delete = styled(HoverIcon)`
  margin: 1rem;
  margin-right: 0;
  align-self: baseline;
`;

export const Flex = styled('div')`
  display: flex;
  justify-content: space-between;
`;

export const QuestionHintBox = styled('div')`
  background-color: var(--exact-white);
  border: 1px solid ${({ color }) => color || blue};
  display: flex;
  padding: 1rem;
  font-size: 13px;
  align-self: center;
  margin-top: 0.5rem;
  font-weight: 400;
  margin-bottom: 1rem;
  border-radius: 10px;
`;

export const HintBoxWrapper = styled('div')`
  display: flex;
  flex-direction: column;
`;

export const HintText = styled('div')`
  color: ${({ color }) => color || black};
  text-align: justify;
  white-space: pre-line;
  & > span:last-child {
    display: block;
    margin-top: 0.2rem;
  }
`;

export const HintIcon = styled(Icon)`
  color: ${({ color }) => color || blue};
  font-size: 26px !important;
  align-self: center;
  margin-inline-end: 1rem;
`;

export const InputTitleWrapper = styled('div')`
  display: flex;
  align-items: center;
  gap: 10px;
`;
export const InputBlock = styled.div`
  padding: 0.5rem;
  // display: flex;
  border-radius: 10px;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  background-color: ${gray};
  transition: all 0.3s;
  border: ${border1};
`;
